<div class="flex flex-column gap-2" [formGroup]="form">
  <app-input-maps-coordinate [form]="form" name="coordinateMaps" label="Coordinate*"></app-input-maps-coordinate>
</div>
